import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
    textColor: {
        color: theme.palette.common.white,
    },
    title: {
        color: theme.palette.common.white,
        fontSize: '36px',
        lineHeight: '59px',
        fontWeight: 'bold'
    },
    actionsContent: {
        justifyContent: 'center',
    },
    actionButton: {
        width: '8rem',
        height: '3rem',
        borderRadius: '0',
        '&.Mui-disabled': {
            backgroundColor: 'gray',
            opacity: .8,
        },
    },
    cancelButton: {
        width: '8rem',
        height: '3rem',
        marginRight: '1rem',
        borderRadius: '0',
        border: '2px solid',
        opacity: '0.4',
        boxSizing: 'border-box',
        borderColor: theme.palette.common.white,
        color: theme.palette.common.white,
        backgroundColor: theme.palette.common.black
    },
    dialogWrapper: {
        width: '100%',
        padding: '32px 0',
    },
    dialogContent: {
        display: "flex",
        justifyContent: "center"
    }
}));

export default useStyles;